import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { GlobalConfigurationComponent } from './global-configuration/global-configuration.component';
import { CicoHelpConfigurationComponent } from './cico-help/cico-help-configuration.component';
import { CONFIGURATION_ROUTES } from './configuration.routes';
import { PodsValidationModule } from '../pods-validation/pods-validation.module';



@NgModule({
    imports: [
        RouterModule.forChild(CONFIGURATION_ROUTES),
        SharedModule,
        CoreModule,
        PodsValidationModule
    ],
  declarations: [
    GlobalConfigurationComponent,
    CicoHelpConfigurationComponent,
  ]
})
export class ConfigurationModule { }
